import React from "react";
import PremiumBlockState from "./context/PremiumBlockState";
import PremiumBlockList from "./components/PremiumBlockList";


const App = ()=>{
    return(
        <PremiumBlockState>
            <PremiumBlockList/>
        </PremiumBlockState>
    )
}
export default App;